(() => {
    if (window.IVRFlashOfferTimerManager) {
      window.IVRFlashOfferTimerManager.init(document);
      return;
    }

    const initTimer = (section) => {
      if (!section || section.dataset.ivrFlashTimerReady === 'true') return;

      const timer = section.querySelector('[data-ivr-offer-timer]');
      if (!timer) return;

      section.dataset.ivrFlashTimerReady = 'true';

      const hoursNode = timer.querySelector('[data-ivr-hours]');
      const minutesNode = timer.querySelector('[data-ivr-minutes]');
      const secondsNode = timer.querySelector('[data-ivr-seconds]');
      const progressNode = section.querySelector('[data-ivr-progress]');
      const labelNode = section.querySelector('[data-ivr-timer-label]');

      const totalSeconds = Math.max(Number.parseInt(timer.dataset.duration || '60', 10), 1);
      const shouldLoop = timer.dataset.loop === 'true';
      const showHours = timer.dataset.showHours === 'true';
      const expiredText = timer.dataset.expiredText || 'Oferta encerrada';

      let remaining = totalSeconds;
      let lastTimestamp = Date.now();
      let intervalId = null;

      const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

      const render = () => {
        let hours = 0;
        let minutes = 0;
        let seconds = remaining;

        if (showHours) {
          hours = Math.floor(remaining / 3600);
          minutes = Math.floor((remaining % 3600) / 60);
          seconds = remaining % 60;
        } else {
          minutes = Math.floor(remaining / 60);
          seconds = remaining % 60;
        }

        if (hoursNode) hoursNode.textContent = pad(hours);
        if (minutesNode) minutesNode.textContent = pad(minutes);
        if (secondsNode) secondsNode.textContent = pad(seconds);

        if (progressNode) {
          const progress = Math.max(0, Math.min(100, (remaining / totalSeconds) * 100));
          progressNode.style.width = `${progress}%`;
        }

        timer.setAttribute(
          'aria-label',
          showHours
            ? `${hours} horas, ${minutes} minutos e ${seconds} segundos restantes`
            : `${minutes} minutos e ${seconds} segundos restantes`
        );
      };

      const finish = () => {
        if (shouldLoop) {
          remaining = totalSeconds;
          lastTimestamp = Date.now();
          render();
          return;
        }

        remaining = 0;
        section.classList.add('ivr-flash-offer--expired');
        if (labelNode) labelNode.textContent = expiredText;
        render();
        if (intervalId) window.clearInterval(intervalId);
      };

      const tick = () => {
        const now = Date.now();
        const elapsed = Math.floor((now - lastTimestamp) / 1000);
        if (elapsed < 1) return;

        lastTimestamp += elapsed * 1000;
        remaining = Math.max(0, remaining - elapsed);

        if (remaining <= 0) {
          finish();
          return;
        }

        render();
      };

      render();
      intervalId = window.setInterval(tick, 250);

      section.ivrFlashTimerCleanup = () => {
        if (intervalId) window.clearInterval(intervalId);
      };
    };

    const collect = (root) => {
      if (!root) return [];
      const instances = [];
      if (root.matches?.('[data-section-type="ivr-flash-offer"]')) instances.push(root);
      root.querySelectorAll?.('[data-section-type="ivr-flash-offer"]').forEach((node) => instances.push(node));
      return instances;
    };
    const init = (root = document) => collect(root).forEach(initTimer);
    const cleanup = (root) => collect(root).forEach((section) => {
      section.ivrFlashTimerCleanup?.();
      delete section.dataset.ivrFlashTimerReady;
    });
    window.IVRFlashOfferTimerManager = { init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanup(event.target));
    document.addEventListener('shopify:block:select', (event) => init(event.target));
  })();
